import React from "react";
import WrapperInput, { IWrapperInput } from "./WrapperInput";
import { TextField, TextFieldProps } from "@mui/material";
import { FieldValues, UseFormRegister } from "react-hook-form";

export interface ITextInput extends Omit<IWrapperInput, "children"> {
  placeholder?: string;
  multiline?: boolean;
  errorMessage?: string | undefined;
  name?: TextFieldProps["name"];
  value?: TextFieldProps["value"];
  disabled?: boolean;
  readOnly?: boolean;
  endAdornment?: React.ReactNode;
  onChange?: TextFieldProps["onChange"];
  register?: UseFormRegister<FieldValues> | undefined;
}

const heights = {
  input: "45px",
};

function TextInput({
  label,
  labelWidth = "20%",
  id,
  placeholder,
  multiline = true,
  required,
  errorMessage,
  name,
  value,
  disabled,
  readOnly,
  endAdornment,
  onChange,
  register,
  ...wrapperProps
}: ITextInput) {
  return (
    <WrapperInput
      id={id}
      label={label}
      required={required}
      labelWidth={labelWidth}
      {...wrapperProps}
    >
      <TextField
        id={id}
        name={name}
        multiline={multiline}
        fullWidth
        placeholder={placeholder}
        autoComplete="off"
        spellCheck={false}
        helperText={errorMessage}
        value={value}
        onChange={onChange}
        slotProps={{ input: { readOnly, disabled, endAdornment } }}
        {...(name ? register?.(name) : {})}
        sx={{
          "& .MuiFormHelperText-root": {
            color: "error.main",
            fontStyle: "italic",
          },
          "& .MuiInputBase-root": {
            height: multiline ? "" : heights.input,
            px: 2,
            py: multiline ? 0.3125 : 0,
            border: "2px solid",
            borderColor: !!errorMessage ? "error.main" : "divider",
            "&:focus-within": {
              borderColor: !!errorMessage ? "error.main" : "primary.main",
            },
            "& .MuiInputBase-input": {
              height: heights.input,
              px: 0,
              py: 1,
            },
            "& fieldset": { border: "none" },
          },
        }}
      />
    </WrapperInput>
  );
}

export default TextInput;
